import clsx from 'clsx'

import { TourDepartureCity } from 'shared/api/tours/search'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  destination: TourDepartureCity
  onClick?: () => void
}

export const DirectionCard = ({ destination, onClick }: Props) => {
  return (
    <div
      onClick={onClick}
      className={s.directionCard}
    >
      <div className={s.leftSide}>
        <ImageLazy
          className={s.flag}
          src={destination.flag ?? undefined}
          alt={destination.name}
        />

        <div className={s.directionText}>
          <p className={clsx('medium-16', s.directionCity)}>
            {destination?.name}
          </p>
        </div>
      </div>

      <AppIcon
        id={AllIcons.ARROW_RIGHT_TARIFF}
        width={24}
        height={24}
      />
    </div>
  )
}
